$('.service-question').on('click',function(e){
  $(this).toggleClass('active');
  $(this).next('.service-answer').toggleClass('active');
  $(this).next('.service-answer').slideToggle();
});
$(window).scroll(function() {
  var scrollDistance = $(window).scrollTop();  
  if(scrollDistance<($(window).height())){
    $('.service-box').each(function(i) {    
      if ($(this).position().top <= scrollDistance + 80) {
        $('.service-right-list li.active').removeClass('active');
        $('.service-right-list li').eq(i).addClass('active');
      }
    });
  }else{
    $('.service-box').each(function(i) {    
      if ($(this).position().top <= scrollDistance+($(window).height()/2)) {
        $('.service-right-list li.active').removeClass('active');
        $('.service-right-list li').eq(i).addClass('active');
      }
    });
  }  
}).scroll();
$('.service-right-list li a').on('click', function(e) {
  e.preventDefault();
  var target = $(this).attr("href");
  $('html, body').stop().animate({
    scrollTop: $(target).offset().top - 80
  }, 500);
  return false;
});
$('.faq-search-input').on('input',function(e){
  var input_val = $(this).val().toLowerCase();
  if(input_val.length>0){
    $('.service-wrap').each(function(e){
      var faq_question = $(this).find('.service-question').text().toLowerCase();
      var faq_answer = $(this).find('.service-answer').text().toLowerCase();
//       if(faq_answer.indexOf(input_val) > -1){
//       	$(this).find('.service-answer').slideDown();
//       }else{
//       	$(this).find('.service-answer').slideUp();
//       }
      if(faq_question.indexOf(input_val) > -1){
        $(this).show();
        $(this).addClass('active');
      }else{
        $(this).hide();
        $(this).removeClass('active');
      }
    });
  }else{        
    $('.service-wrap').show();
    //$('.service-answer').slideUp();
  }
  $('.faq-category').each(function(e){
    if($(this).find('.service-wrap.active').length>0){
      $(this).closest('.faq-category').show(); 
      $(this).closest('.faq-category').addClass('active'); 
    }else{
      $(this).closest('.faq-category').hide();
      $(this).closest('.faq-category').removeClass('active');
    }
  });
  if($('.faq-category.active').length>0){
  	$('.no-result-cls').hide();
  }else{
  	$('.no-result-cls').show();
  }
});